import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall, weightMedium } from 'src/components/css'

export const dividerStyle = css`
  margin: 12px 0 !important;
  background-color: ${colors.SECONDARY_200} !important;
`

export const sectionTitleStyle = css`
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 14.4px;
  letter-spacing: 1.44px;
  text-transform: uppercase;
  color: ${colors.NEUTRAL_100};
  padding: 0 16px;
  margin: 16px 0 8px 0;
`

export const sectionTitleTransitionStyle = (collapsed: boolean) => css`
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 14.4px;
  letter-spacing: 1.44px;
  text-transform: uppercase;
  color: ${colors.NEUTRAL_100};
  padding: 0 16px;
  margin: 16px 0 8px 0;
  overflow: hidden;
  opacity: ${collapsed ? 0 : 1};
  max-height: ${collapsed ? 0 : '24px'};
  margin-top: ${collapsed ? 0 : '16px'};
  margin-bottom: ${collapsed ? 0 : '8px'};
  transition: opacity 0.2s ease-in-out, max-height 0.2s ease-in-out,
    margin 0.2s ease-in-out;
`

export const recentsGroupLabelStyle = css`
  padding: 8px 16px 4px 16px;
`

export const itemLinkStyle = css`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  width: 100%;
  text-decoration: none;
  color: inherit;
  &:hover {
    background: ${colors.SECONDARY_400};
  }
  padding: 8px 16px 4px 16px;
`

export const itemImageContainerStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: white;
  border-radius: 4px;
  border: 1px solid ${colors.NEUTRAL_0};
  flex-shrink: 0;
`

export const itemImageStyle = css`
  border-radius: 4px;
  border: 1px solid ${colors.NEUTRAL_0};
  flex-shrink: 0;
  object-fit: contain;
`

export const itemTextStyle = css`
  ${paragraphSmall}
  ${weightMedium}
  color: ${colors.NEUTRAL_0};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const sidebarMenuContainerStyle = (collapsed: boolean) => css`
  padding: ${collapsed ? '0 8px' : '0'};
  padding-left: 8px;
  ${collapsed ? 'width: 54px;' : ''}
  /* Ensure overflow is visible for drag-and-drop transforms */
  & .ant-menu {
    overflow: visible !important;
  }

  & .ant-menu-item {
    ${collapsed && 'padding-top: 4px !important;'}
    /*border: 1px solid red;*/
    justify-content: center;
    align-items: center;
    height: 40px !important;
    line-height: 40px !important;
    margin: 4px 0 !important;
    border-radius: 8px !important;
    ${!collapsed
      ? 'padding-left: 16px !important;'
      : 'padding-left: 9px !important;'}

    position: relative;
    overflow: visible !important;
    transition: padding 0.2s ease-in-out;

    /* Ensure title wrapper allows overflow for transforms */
    & .ant-menu-title-content {
      overflow: visible !important;
    }

    &.ant-menu-item-selected {
      background-color: ${colors.SECONDARY_600} !important;
      color: ${colors.PRIMARY} !important;
      font-weight: 500 !important;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 24px;
        background-color: transparent;
        border-radius: 0 4px 4px 0;
      }

      .anticon {
        color: ${colors.PRIMARY} !important;
      }
    }

    &:not(.ant-menu-item-selected) {
      color: ${colors.NEUTRAL_0} !important;

      .anticon {
        color: ${colors.NEUTRAL_50} !important;
      }
    }

    &:hover:not(.ant-menu-item-selected) {
      background-color: ${colors.SECONDARY_400} !important;
    }

    a {
      color: inherit !important;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  & .ant-menu-submenu {
    & .ant-menu-submenu-title {
      height: 40px !important;
      line-height: 40px !important;
      margin: 4px 0 !important;
      border-radius: 8px !important;
      ${!collapsed ? 'padding-left: 16px !important;' : ''}
      color: ${colors.NEUTRAL_0} !important;
      transition: padding 0.2s ease-in-out;

      &:hover {
        background-color: ${colors.SECONDARY_400} !important;
      }

      .anticon {
        color: ${colors.NEUTRAL_50} !important;
      }

      .ant-menu-submenu-arrow {
        color: ${colors.NEUTRAL_50} !important;
        right: 16px !important;
      }
    }

    &.ant-menu-submenu-open > .ant-menu-submenu-title {
      .anticon {
        color: ${colors.NEUTRAL_0} !important;
      }

      .ant-menu-submenu-arrow {
        color: ${colors.NEUTRAL_0} !important;
      }
    }
  }

  & .ant-menu-submenu-inline .ant-menu-submenu-title {
    padding-right: 40px !important;
  }

  & .ant-menu-sub {
    background: transparent !important;
    padding-left: 0 !important;
    padding-right: 0 !important;

    & .ant-menu-item-group-title {
      padding: 0 !important;
    }

    & .ant-menu-item {
      padding-left: 0 !important;
      padding-right: 0 !important;
      height: auto !important;
      line-height: normal !important;
      margin: 0 !important;
      border-radius: 0 !important;

      &:hover {
        background-color: transparent !important;
      }
    }
  }
`

export const menuStyle = {
  background: 'transparent',
  border: 'none',
}
